export default "__VITE_ASSET__DOEL6MKR__"